var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDot2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99695 8.66339C8.365 8.66339 8.66336 8.36503 8.66336 7.99698C8.66336 7.62893 8.365 7.33057 7.99695 7.33057C7.6289 7.33057 7.33054 7.62893 7.33054 7.99698C7.33054 8.36503 7.6289 8.66339 7.99695 8.66339Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6618 8.66339C13.0299 8.66339 13.3282 8.36503 13.3282 7.99698C13.3282 7.62893 13.0299 7.33057 12.6618 7.33057C12.2938 7.33057 11.9954 7.62893 11.9954 7.99698C11.9954 8.36503 12.2938 8.66339 12.6618 8.66339Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33206 8.66339C3.70011 8.66339 3.99847 8.36503 3.99847 7.99698C3.99847 7.62893 3.70011 7.33057 3.33206 7.33057C2.96401 7.33057 2.66565 7.62893 2.66565 7.99698C2.66565 8.36503 2.96401 8.66339 3.33206 8.66339Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDot2);
export default __webpack_public_path__ + "static/media/threeDot2.622ea0290c44a57190631e1b45224981.svg";
export { ForwardRef as ReactComponent };